import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "flex-fill font-weight-bold" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "flex-fill" }
const _hoisted_5 = { class: "text-nowrap" }

import {MessageNavigatorPayloadInterface} from "~/core-ui/vue/chat/CoreUiChatHistoryExposeInterface";
import {__} from "~/ts/library/Translate";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {ref} from "vue";


const __default__ = {
    name: "CoreUiChatHistoryMessageNavigator"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    payload: {}
  },
  emits: ["update:payload", "move-to"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let currentIndex = ref(props.payload.messageIds.length - 1);

let emits = __emit;

function moveTo(delta: number) {
    let newIndex = currentIndex.value + delta;
    let maxIndex = props.payload.messageIds.length - 1;
    if (newIndex < 0) {
        newIndex = maxIndex;
    } else if (newIndex > maxIndex) {
        newIndex = 0;
    }
    currentIndex.value = newIndex;
    emits("move-to", props.payload.messageIds[newIndex]);
}

moveTo(0);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "message-navigator p-2 pl-3 pr-3" }, {
    default: _withCtx(() => [
      _createVNode(ElCardSection, { padding: false }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(__props.payload.title), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                link: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:payload', null)))
              }, {
                default: _withCtx(() => [
                  _createVNode(FontAwesomeIcon, {
                    class: "text-muted",
                    icon: "times"
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(__)("%1$d из %2$d", _unref(currentIndex) + 1, __props.payload.messageIds.length)), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                link: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (moveTo(-1)))
              }, {
                default: _withCtx(() => [
                  _createVNode(FontAwesomeIcon, { icon: "chevron-up" })
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                link: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (moveTo(1)))
              }, {
                default: _withCtx(() => [
                  _createVNode(FontAwesomeIcon, { icon: "chevron-down" })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})